var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-wallpaper-item"},[_c('img',{attrs:{"src":_vm.data.preview_jpg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }